import { Table, Tag } from "antd";
import React from "react";
import "../../common.scss";
import dayjs from "dayjs";
import eyeIcon from "../../assets/icons/eyeIcon.svg";
import { useNavigate } from "react-router-dom";
import { ConvertFirstLatterToCapital } from "../../utility";
export const formatStatus = (status) =>
  status
    ?.toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
function ApplicationListTable({
  data,
  totalItems,
  currentPage,
  pageSize,
  onChangePage,
  onChangePageSize,
}) {
  const navigate = useNavigate();

  const columns = [
    {
      title: "Application ID",
      dataIndex: "applicationId",
      key: "applicationId",
      width: 250,
      render: (text) => <strong>{text}</strong>,
      fixed: "left",
    },
    {
      title: "Name",
      dataIndex: ["dynamicData", "applicantName"],
      key: "applicantName",
      width: 200,
    },
    {
      title: "Mobile",
      dataIndex: ["dynamicData", "phone"], // fallback if mobile exists
      key: "phone",
      render: (_, record) => record.dynamicData?.phone || "-",
      width: 200,
    },
    {
      title: "Amount",
      dataIndex: "amountRequired",
      key: "amountRequired",
      render: (amount) =>
        amount !== null && amount !== undefined && !isNaN(amount)
          ? `₹${Number(amount).toLocaleString()}`
          : "—",
      width: 200,
    },
    {
      title: "Approved Amount",
      dataIndex: "approvedDisplay",
      key: "approvedDisplay",
      render: (amount) =>
        amount !== null && amount !== undefined && !isNaN(amount)
          ? `₹${Number(amount).toLocaleString()}`
          : "—",
      width: 200,
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 200,

      render: (status) => {
        const statusColors = {
          submitted: "green",
          "in progress": "yellow",
          completed: "green",
          new: "gold",
          "need more info": "orange",
          rejected: "red",
          approved: "cyan",
        };

        const color = statusColors[status?.toLowerCase()] || "blue";

        return <Tag color={color}>{formatStatus(status)}</Tag>;
      },
    },
    {
      title: "Submitted Date",
      dataIndex: "created_at",
      key: "created_at",
      render: (date) => dayjs(date).format("DD MMM YYYY"),
      width: 200,
    },
    {
      title: "Action",
      key: "action",
      width: 100,
      fixed: "right",
      render: (_, record) => (
        <div className="d-flex gap-1">
          <img
            src={eyeIcon}
            style={{ width: "20px", cursor: "pointer" }}
            onClick={() => navigate(`/applications/${record._id}`)}
          />
        </div>
      ),
    },
  ];

  return (
    <div>
      <Table
        className="commonListTable"
        columns={columns}
        dataSource={data}
        rowKey={(record) => record._id}
        scroll={{
          x: 1500,
          y: 400,
        }}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: totalItems,
          onChange: onChangePage,
          onShowSizeChange: (current, size) => onChangePageSize(size),
          showSizeChanger: true,
        }}
        bordered
      />
    </div>
  );
}

export default ApplicationListTable;
